import EditorCanvas from '@EditorCanvas/EditorCanvas.js'
import { DataController } from '@Utils/DataController.js'
import './style.css'
import EditorUI from '@Views/EditorUI.svelte'
import { GuideController } from '@Views/Guide/GuideController.js'
import { ColorSchemeManager } from '@Utils/ColorSchemeManager.js'
import * as jose from 'jose'
import { mount } from 'svelte'
import Service from '@Renderer/Service.js'

let os = 'Unknown OS'
let userAgent = window.navigator.userAgent
let colorSchemeManager = new ColorSchemeManager(true, 'dark', true)
const renderer = new Service()

if (userAgent.indexOf('Win') != -1) os = 'win'
if (userAgent.indexOf('Mac') != -1) os = 'mac'
if (userAgent.indexOf('X11') != -1) os = 'win'
if (userAgent.indexOf('Linux') != -1) os = 'win'

if (localStorage.getItem(`tool_icon_iconName`)?.toLowerCase().includes("menu")) {
	console.info("resetting selected icon")
	localStorage.removeItem(`tool_icon_iconName`)
}
if (localStorage.getItem(`tool_holeicon_iconName`)?.toLowerCase().includes("menu")) {
	console.info("resetting selected icon")
	localStorage.removeItem(`tool_holeicon_iconName`)
}
document.body.classList.add(`os-${os}`)
const urlParams = new URLSearchParams(window.location.search)
window.dispatchError = function(data) {
	let event = new Event('error')
	event.data = data
	window.dispatchEvent(event)
}

let dev = urlParams.get('dev') === 'true' ?? false
class EditorState {
	listeners = {}
	deferUpdates = false
	constructor() {
		this.state = {}
	}
	set(key, value) {
		this.state[key] = value
	}
	get(key) {
		return this.state[key]
	}

	off(event, cb) {
		if (!this.listeners[event]) {
			return
		}
		this.listeners[event] = this.listeners[event].filter((c) => c != cb)
	}
	on(event, cb) {
		if (!this.listeners[event]) {
			this.listeners[event] = []
		}
		this.listeners[event].push(cb)
	}
	removeAllEventListerners() {
		this.listeners = {}
	}
	setRendererOwner(owner) {
		if (!owner) {
			owner = "preview"
		}
		this.set('rendererOwner', owner)
		this.trigger('rendererOwnerChanged', owner)
	}
	trigger(event, data) {
		if (this.deferUpdates) {
			return
		}
		if (!this.listeners[event]) {
			return
		}
		for (let cb of this.listeners[event]) {
			cb(data)
		}
	}
}
const editorState = new EditorState()
function getUserRole(token) {
	if (!token) {
		return 'User'
	}
	try {
		let obj = jose.decodeJwt(token)
		if (obj['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']) {
			return obj['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
		}
		return 'User'
	} catch (error) {
		console.log(error)
		return 'User'
	}
}
function getCookie(name) {
	const value = `; ${document.cookie}`
	const parts = value.split(`; ${name}=`)
	if (parts.length === 2) return parts.pop().split(';').shift()
}
function getToken() {
	let token = getCookie('token')

	const queryToken = urlParams.get('token')
	if (!token) {
		token = queryToken
	}

	return token
}
function init(configuration, token) {
	if (!token) {
		token = getCookie('token')
	}
	if (!token && dev !== true) {
		console.warn('No token found')
	}
	let role = getUserRole(token)
	dev = dev && configuration.MODE === 'dev'
	if (dev) {
		role = 'GolfOfficeAdministrator'
	}

	let canvas = new EditorCanvas('map', {
		showIntersectingElements: localStorage.getItem('showIntersectingElements') === 'true',
		showOverlappingElements: localStorage.getItem('showOverlappingElements') === 'true',
		serviceKeys: {
			azureMaps: configuration.VITE_AZURE_MAPS_KEY,
			bing: configuration.VITE_BING_API_KEY,
			google: configuration.VITE_GOOGLE_API_KEY
		}
	})
	let backendUrl = dev === true ? "http://localhost:4033" : configuration.VITE_GOLF_OFFICE_API_URL
	function onLicenseChanged(s) {
		window.dispatchEvent(new CustomEvent('licenseChanged', { detail: { subscription: s } }))
		console.log('License changed', s)
	}
	const controller = new DataController(canvas, backendUrl, token, {
		localTest: dev === true,
		googleKey: configuration.VITE_GOOGLE_API_KEY,
		azureMapsKey: configuration.VITE_AZURE_MAPS_KEY,
		golfOfficeFrontendURL: configuration.VITE_GOLF_OFFICE_FRONTEND_URL
	})
	let codes = controller.getCodes()
	controller.on('statusUpdated', function (s) {
		if (s.code === codes.error) {
			document.body.classList.add('fatal-error')
		} else {
			document.body.classList.remove('fatal-error')
		}
	})
	controller.on('licenseChanged', onLicenseChanged)
	controller.on('authorizationStatus', function (unauthorized) {
		if (unauthorized) {
			document.body.classList.add('unauthorized')
		} else {
			document.body.classList.remove('unauthorized')
		}
	})
	if (import.meta.env.VITE_DOWN_FOR_MAINTAINANCE !== 'true') {
		controller.start()
	}

	let guide = new GuideController(canvas, controller)
	let prop = {
		isAdmin: role === 'GolfOfficeAdministrator',
		isDev: dev,
		canvas: canvas,
		controller: controller,
		renderer: renderer,
		editorState: editorState,
		guideController: guide,
		colorSchemeManager: colorSchemeManager,
		config: {
			golfOfficeFrontendURL: configuration.VITE_GOLF_OFFICE_FRONTEND_URL
		}
	}
	mount(EditorUI, { target: document.querySelector('[data-gui]'), props: prop })
	document.addEventListener('keydown', (e) => {
		if (document.activeElement) {
			if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
				return
			}
			document.activeElement.blur()
		}
		if (e.key !== 'Escape') {
			return
		}
		canvas.escape()
	})
	// document.addEventListener('mousedown', (e) => {
	// 	let el = document.createElement('div');
	// 	el.style.left = `${e.clientX - 25}px`;
	// 	el.style.top = `${e.clientY - 25}px`;
	// 	el.classList.add('click-impact');
	// 	el.addEventListener('animationend', () => {
	// 		el.remove();
	// 	});
	// 	document.body.appendChild(el);
	// })
	// document.addEventListener('keydown', (e) => {
	// 	// let el = document.createElement('div');
	// 	// el.style.left = `${e.clientX}px`;
	// 	// el.style.top = `${e.clientY}px`;
	// 	// el.innerText = e.key;
	// 	// el.classList.add('key-down-effect');
	// 	// el.addEventListener('animationend', () => {
	// 	// 	el.remove();
	// 	// });
	// 	// document.body.appendChild(el);
	// 	window.dispatchEvent(new CustomEvent('info', { detail: { message: `${e.key} key pressed` } }))
	// });
}
window.addEventListener(
	'message',
	function (ev) {
		if (ev.data.action === 'getCacheConfiguration') {
			window.postMessage({
				id: ev.data.id,
				action: 'setCacheConfiguration',
				payload: {
					precacheName: import.meta.env.VITE_PRECACHE_NAME,
					runtimeCacheName: import.meta.env.VITE_RUNTIME_CACHE_NAME
				}
			})
		}
	},
	false
)
init(import.meta.env, getToken())
if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register(`/CacheServiceWorker.js?v=${APP_VERSION}`)
		.then((registration) => {
			registration.addEventListener('updatefound', () => {
				const installingWorker = registration.installing
				console.log('A new service worker is being installed:', installingWorker)
			})
		})
		.catch((error) => {
			console.error(`Service worker registration failed: ${error}`)
		})
} else {
	console.error('Service workers are not supported.')
}
